import clsx from 'clsx'
import styles from './header.module.css'
import { ReactComponent as HelpIcon } from '../../assets/help_icon.svg'
import { ReactComponent as MeshOutIcon } from '../../assets/mesh_out_icon.svg'

import { ListTile, PrimaryButton } from '../common'
import { useMessagingService } from '../../agent'

type Props = {
  onMenuItemPressed: () => void
}

export const PortalMenu = ({ onMenuItemPressed }: Props) => {
  const faqLink = 'https://www.hushmesh.com/faq.html'

  const messagingService = useMessagingService()

  const openHelp = () => {
    window.open(faqLink, '_blank')
    onMenuItemPressed()
  }

  const meshout = async () => {
    onMenuItemPressed()
    await messagingService.meshout()
    window.location.href = '/'
  }

  return (
    <div className={styles.menu}>
      <ListTile
        className={clsx(
          styles.itemHolder,
          styles.itemBottomBorder,
          styles.clickableItem,
        )}
        onClick={openHelp}
      >
        <div>
          <HelpIcon className={styles.helpIcon} />
          <span>Help & Support</span>
        </div>
      </ListTile>

      <div className={styles.itemHolder}>
        <PrimaryButton
          label={'Mesh Out'}
          variant="outlined"
          tone="secondary"
          icon={<MeshOutIcon />}
          onClick={meshout}
          className={styles.menuItemButton}
        />
      </div>
    </div>
  )
}
